<template>
  <div>
    <label v-if="label" class="custom-input-group__ttl">
      {{ $t(label) }} <span v-if="required">*</span>
    </label>

    <div v-if="item[property]">
      <table class="table table-striped table-hover">
        <tbody>
        <tr v-for="image in item[property]" :key="image.id">
          <td>
            <img :src="imagePath(image)" alt="" width="200" />
          </td>
          <td>
            <button type="button" @click.prevent="deleteImage(image.id)">Delete</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div>
      <input type="file" :multiple="multiple" @change="imageSelected($event.target.files)" />
    </div>
  </div>
</template>

<script>
  import axios from '../../interceptor'

  export default {
    name: 'UploadImage',
    props: {
      item: {
        type: Object,
        required: true
      },
      property: {
        type: String,
        required: true
      },
      label: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      imagePath (image) {
        return process.env.API_URL + '/images/200/' + image.contentUrl
      },
      imageSelected(files) {
        Array.from(files).forEach(file => {
          let config = {header: {'Content-Type': 'multipart/form-data'}}
          let data = new FormData();

          data.append('image', file)

          axios.post(`${process.env.API_URL}/images`, data, config)
              .then(response => {
                this.item[this.property].push(response.data)
                this.$toastr.s(this.$t('Image uploaded'))
              })
              .catch(e => {
                this.$toastr.e(e.message, this.$t('error_occurred'))
              })
        })
      },
      deleteImage(id) {
        if (confirm('Are you sure?')) {
          let value = []
          let images = this.item[this.property]

          value = images.filter(el => {
            return el.id !== id
          })

          this.item[this.property] = value
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/UploadImage.vue